import { render, staticRenderFns } from "./ModalTTN.vue?vue&type=template&id=08f25c4c&"
import script from "./ModalTTN.vue?vue&type=script&lang=js&"
export * from "./ModalTTN.vue?vue&type=script&lang=js&"
import style0 from "./ModalTTN.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports